/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Bradford Factor report entry for an employee
 * @export
 * @interface ReportBradfordFactor
 */
export interface ReportBradfordFactor {
    /**
     * A deterministic identifier for the report entry.
     * @type {string}
     * @memberof ReportBradfordFactor
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof ReportBradfordFactor
     */
    employeeId: number;
    /**
     * The number of absence occasions within the date range
     * @type {number}
     * @memberof ReportBradfordFactor
     */
    occasions: number;
    /**
     * The total working days lost within the date range
     * @type {number}
     * @memberof ReportBradfordFactor
     */
    totalDays: number;
    /**
     * The Bradford Factor score (occasions^2 * totalDays)
     * @type {number}
     * @memberof ReportBradfordFactor
     */
    score: number;
}

/**
 * Check if a given object implements the ReportBradfordFactor interface.
 */
export function instanceOfReportBradfordFactor(value: object): value is ReportBradfordFactor {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('employeeId' in value) || value['employeeId'] === undefined) return false;
    if (!('occasions' in value) || value['occasions'] === undefined) return false;
    if (!('totalDays' in value) || value['totalDays'] === undefined) return false;
    if (!('score' in value) || value['score'] === undefined) return false;
    return true;
}

export function ReportBradfordFactorFromJSON(json: any): ReportBradfordFactor {
    return ReportBradfordFactorFromJSONTyped(json, false);
}

export function ReportBradfordFactorFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportBradfordFactor {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'employeeId': json['employeeId'],
        'occasions': json['occasions'],
        'totalDays': json['totalDays'],
        'score': json['score'],
    };
}

  export function ReportBradfordFactorToJSON(json: any): ReportBradfordFactor {
      return ReportBradfordFactorToJSONTyped(json, false);
  }

  export function ReportBradfordFactorToJSONTyped(value?: ReportBradfordFactor | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'employeeId': value['employeeId'],
        'occasions': value['occasions'],
        'totalDays': value['totalDays'],
        'score': value['score'],
    };
}

